// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"315":"af802993","539":"73f20fb1","988":"73f20fb1"}[chunkId] + ".chunk.css";
};